import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const InVitroTrialIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.38599 10.5759V9.19202L17.614 9.19202C17.614 9.19202 17.614 9.67371 17.614 10.5759C17.614 14.781 14.2051 18.19 10 18.19C5.7949 18.19 2.38599 14.781 2.38599 10.5759Z"
        fill="var(--cdl-fg-muted)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3333 8.47266V10.5759C18.3333 15.1783 14.6024 18.9092 10 18.9092C5.39763 18.9092 1.66667 15.1783 1.66667 10.5759V8.47266L18.3333 8.47266ZM3.10531 9.9113V10.5759C3.10531 14.3837 6.19217 17.4706 10 17.4706C13.8078 17.4706 16.8947 14.3837 16.8947 10.5759V9.91194L3.10531 9.9113Z"
        fill="currentColor"
      />
      <path
        d="M2.38599 9.16675C2.38599 4.96164 5.7949 1.55273 10 1.55273C14.2051 1.55273 17.614 4.96164 17.614 9.16675C17.614 13.3719 14.2051 16.7808 10 16.7808C5.7949 16.7808 2.38599 13.3719 2.38599 9.16675Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66667 9.16671C1.66667 4.56433 5.39763 0.833374 10 0.833374C14.6024 0.833374 18.3333 4.56433 18.3333 9.16671C18.3333 13.7691 14.6024 17.5 10 17.5C5.39763 17.5 1.66667 13.7691 1.66667 9.16671ZM10 2.27201C6.19217 2.27201 3.10531 5.35887 3.10531 9.16671C3.10531 12.9745 6.19217 16.0614 10 16.0614C13.8078 16.0614 16.8947 12.9745 16.8947 9.16671C16.8947 5.35887 13.8078 2.27201 10 2.27201Z"
        fill="currentColor"
      />
      <path
        d="M10.2949 14.2953C9.49075 15.0995 8.18701 15.0995 7.38289 14.2953C6.57877 13.4912 6.57877 12.1875 7.38289 11.3834C7.68939 11.0769 8.06848 10.8872 8.46483 10.8143C9.24549 10.6709 10.1366 10.6179 10.6979 10.0566C11.2591 9.49536 11.3121 8.60421 11.4556 7.82355C11.5285 7.42721 11.7181 7.04812 12.0246 6.74162C12.8288 5.9375 14.1325 5.9375 14.9366 6.74162C15.7407 7.54574 15.7407 8.84947 14.9366 9.6536C14.6527 9.93755 14.3064 10.1212 13.9419 10.2046C13.1502 10.3858 12.2405 10.4506 11.6662 11.0249C11.0919 11.5992 11.0271 12.5089 10.8459 13.3006C10.7625 13.6651 10.5788 14.0114 10.2949 14.2953Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        d="M8.91169 8.35919C8.10757 9.16331 6.80383 9.16331 5.99971 8.35919C5.19559 7.55507 5.19559 6.25133 5.99971 5.44721C6.80383 4.64309 8.10757 4.64309 8.91169 5.44721C9.71581 6.25133 9.71581 7.55507 8.91169 8.35919Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InVitroTrialIcon;
